import { render, staticRenderFns } from "./OnboardingCreatorBond.vue?vue&type=template&id=f580b090&"
import script from "./OnboardingCreatorBond.vue?vue&type=script&lang=js&"
export * from "./OnboardingCreatorBond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports